import removePageLoader from '../utils/ui/remove-page-loader'

export default {
  async mounted () {
    this.$nextTick(removePageLoader)
  }
}
